import type { StyleLayer } from './utils/types'

export const layers_boundaries: StyleLayer[] = [
  {
    id: 'category_municipality_gemeinden',
    type: 'line',
    filter: ['has', 'category_municipality'],
    paint: {
      'line-color': '#efc6a9',
      'line-dasharray': [2.5, 1, 1, 1],
      'line-opacity': 0.6,
      'line-width': 1.5,
    },
  },
  {
    id: 'category_district_landkreis',
    type: 'line',
    filter: ['has', 'category_district'],
    paint: {
      'line-color': '#eab590',
      'line-dasharray': [2.5, 1, 1, 1],
      'line-opacity': 0.6,
      'line-width': 2,
    },
  },
]
